/* --------------------------------------------------------------------------------------
   students.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const studentsComponent  = {
    template: require('./students.html'),
    controller: 'studentsCtrl',
    controllerAs: 'vm',
    bindings: {
      back: '&',
      next: '&'
    }
}

export class studentsCtrl {
  /*@ngInject*/
  constructor (commonService, dataService, appService, printTestsService, $state, $timeout) {
    this.commonService = commonService
    this.dataService = dataService
    this.appService = appService
    this.printTestsService = printTestsService
    this.$state = $state
    this.$timeout = $timeout
  }
  $onInit () {
    this.commonService.setDefaultBackground()
    this.tableWidth = this.commonService.getScreenWidth() > 801 ? '942':'760'
    this.className = this.appService.className
    this.testName = this.appService.testName
    this.all = false
    this.dataService.GetRoster(this.appService.classId)
      .then((result) => {
        this.items = result
        this.answerKey = true
        angular.forEach(this.items, (item) => item.selected = false)
        $('#scrollableContainer').xrxscrollable()
      })
      .catch(error => {
        this.appService.handleError(error)
          .then(result => {this.error = result})
      })
  }

  toggleSelectAll() {
    this.all = !this.all
    angular.forEach(this.items, (item) => item.selected = this.all)
    angular.element('#submit-button').xrxbutton({disabled: !this.all})
  }

  toggleSelected(item) {
    item.selected = !item.selected
    let anyStudentSelected = this.items.some(i => { return i.selected })
    angular.element('#submit-button').xrxbutton({disabled: !anyStudentSelected})
    this.all = this.items.every(i => { return i.selected })
  }

  submit () {
    this.printing = true
    this.appService.answerKey = this.answerKey
    this.appService.selectedStudentIds = this.items.filter(item => item.selected).map(item => item.ID)

    if (this.appService.selectedStudentIds.length == this.items.length)
      this.appService.selectedStudentIds = null

    this.printTestsService.printTests().then(() => {
      this.printing = false
      setTimeout(() => {
      this.$state.go('main')},500)
    })
  }
  errorClosed() {
    return this.appService.errorClosed(this.error)
  }
}



// WEBPACK FOOTER //
// ./src/app/printTests/components/students.component.js